@if (!isOnCancelRoute()) {
  <button class="close-btn" (click)="onClose()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
}

<router-outlet></router-outlet>